import { render, staticRenderFns } from "./eduIndex.vue?vue&type=template&id=5b817040&"
import script from "./eduIndex.vue?vue&type=script&lang=js&"
export * from "./eduIndex.vue?vue&type=script&lang=js&"
import style0 from "./eduIndex.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports